/**
 * The weekend Drinks card (owner, 2026-10-24): from Thursday 14:00 to
 * Sunday 23:59, Nairobi time, the homepage "Shop by category" grid's 4th
 * card is always Drinks. Outside that window the grid rotates as usual.
 *
 * The time is the server's, not the visitor's device: a wrong phone clock
 * must not decide what the homepage shows.
 */

export const DRINKS_SLUG = "drinks";

// Nairobi is UTC+3 all year (no daylight saving), the same fixed offset
// backend/app/notifications.py uses for EAT.
const NAIROBI_OFFSET_MS = 3 * 60 * 60 * 1000;
const THURSDAY = 4;
const WINDOW_START_HOUR = 14;

/** True from Thursday 14:00 to Sunday 23:59:59, Nairobi time. */
export function isDrinksWindow(epochMs) {
  if (!Number.isFinite(epochMs)) return false;
  const nairobi = new Date(epochMs + NAIROBI_OFFSET_MS);
  const day = nairobi.getUTCDay(); // 0 = Sunday
  if (day === THURSDAY) return nairobi.getUTCHours() >= WINDOW_START_HOUR;
  return day === 5 || day === 6 || day === 0;
}

/**
 * The server clock: the website's own `Date` header (same origin, so it is
 * readable). Falls back to the device clock if the header can't be read.
 */
export async function serverNow() {
  try {
    const res = await fetch("/", { method: "HEAD", cache: "no-store" });
    const parsed = Date.parse(res.headers.get("date") || "");
    if (Number.isFinite(parsed)) return parsed;
  } catch {
    // fall through to the device clock
  }
  return Date.now();
}
